var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"s-box"},[_c('h4',{staticClass:"category"},[_vm._v(_vm._s(_vm.catename))]),_vm._l((_vm.skills),function(skill){return _c('Skill',{key:skill.id,attrs:{"skill":skill}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }